import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivateFn, Router } from "@angular/router";
import { SessionService } from "../shared/services/session.service";

@Injectable({
  providedIn: "root",
})
export class ResetPasswordGuardService {
  constructor(
    private sessionService: SessionService,
    private router: Router
  ) {}

  /**
   * Determines whether the route can be activated. A reset link (carrying a "token" query parameter)
   * is always let through, even when the user looks logged in: their stored tokens may be stale, in
   * which case the login dialog opens on top of the page and opens the reset password dialog with
   * that code itself, and redirecting to /profile would lose the code.
   * @param route The route being activated
   * @return True if the route can be activated, false otherwise
   */
  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (route.queryParamMap.has("token")) {
      return true;
    }
    return this.checkNotLogin();
  }

  /**
   * Checks whether the user is not currently logged in, redirecting to /profile if they are.
   * @return True if the user is not logged in, false otherwise
   */
  checkNotLogin(): boolean {
    if (!this.sessionService.isLoggedIn) {
      return true;
    } else {
      this.router.navigate(["/profile"], { state: { changePassword: true } });
      return false;
    }
  }
}

export const ResetPasswordGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  return inject(ResetPasswordGuardService).canActivate(route);
};
